import { render, staticRenderFns } from "./BannerWebpart.vue?vue&type=template&id=4e818729&scoped=true"
import script from "./BannerWebpart.ts?vue&type=script&lang=ts&external"
export * from "./BannerWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./BannerWebpart.vue?vue&type=style&index=0&id=4e818729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e818729",
  null
  
)

export default component.exports